"use client";

import type * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const labelVariants = cva(
  "font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      variant: {
        default: "text-sm",
        xs: "text-xs text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

const Label = ({
  ref,
  className,
  variant,
  ...props
}: React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants> & {
    ref?: React.Ref<React.ElementRef<typeof LabelPrimitive.Root>>;
  }) => (
  <LabelPrimitive.Root
    data-slot="label"
    ref={ref}
    className={cn(labelVariants({ variant }), className)}
    {...props}
  />
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
